import { createZodDto } from 'nestjs-zod/dto';
import { userIdentitySchema } from './identity';
import { scramClientFinalSchema } from './scram';
export { ScramClientFirstDto as UserPasswordChangeClientFirstDto } from './scram';
const userPasswordChangeFinalSchema = scramClientFinalSchema.extend(userIdentitySchema.shape);
export class UserPasswordChangeClientFinalDto extends createZodDto(userPasswordChangeFinalSchema) {
}
